import script from "./clients-details.vue?vue&type=script&setup=true&lang=js"
export * from "./clients-details.vue?vue&type=script&setup=true&lang=js"

import "./clients-details.vue?vue&type=style&index=0&id=0459f9c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0459f9c4"]])

export default __exports__